import { corners, padding, typography } from "../../styles";
import { applyOpacity } from "../../styles/utils";
import React from "react";
import styled from "styled-components";
type ToggleOption = {
  label: string;
  value: string;
};
type ToggleProps = {
  onToggle: (value: string) => void;
  options: ToggleOption[];
  selectedValue: string;
};
const ToggleContainer = styled.div`
  display: flex;
  ${corners.m};
  gap: 0.625rem;
  ${padding.xs}
  background-color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.05, true, theme.brand.cssVars["--d-surface"])};
`;
const ToggleButton = styled.button`
  cursor: pointer;
  border: none;
  ${corners.m};
  ${typography.small};
  text-transform: capitalize;

  &.active {
    background-color: ${({
  theme
}) => theme.brand.cssVars["--d-card"]};
    color: ${({
  theme
}) => theme.brand.cssVars["--d-text"]};
  }

  &:not(.active) {
    color: ${({
  theme
}) => theme.brand.cssVars["--d-muted"]};
    background-color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.05, true, theme.brand.cssVars["--d-surface"])};
  }
`;
export function Toggle({
  options,
  selectedValue,
  onToggle
}: ToggleProps) {
  return <ToggleContainer data-sentry-element="ToggleContainer" data-sentry-component="Toggle" data-sentry-source-file="Toggle.tsx">
      {options.map(option => <ToggleButton key={option.value} className={selectedValue === option.value ? "active" : ""} onClick={() => onToggle(option.value)}>
          {option.label}
        </ToggleButton>)}
    </ToggleContainer>;
}
export default Toggle;